<div class="card">
  <div
    class="card-header d-flex flex-column flex-md-row justify-content-between align-items-end w-100"
  >
    <div class="flex-grow-1 me-md-2 mb-2 mb-md-0 w-100 w-md-auto">
      <app-search (searchChange)="this.onSearch($event)"></app-search>
    </div>
    <button
      type="button"
      class="btn btn-primary w-100 w-md-auto"
      style="max-width: 200px"
      data-bs-toggle="modal"
      data-bs-target="#notificationFormModal"
      (click)="onNewNotificationClick()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-plus me-2"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 5l0 14"></path>
        <path d="M5 12l14 0"></path>
      </svg>
      Nueva notificación
    </button>
  </div>
  <div class="table-responsive">
    <table class="table card-table table-vcenter datatable w-100">
      <thead>
        <tr>
          <th>Mensaje</th>
          <th class="text-center">Estado</th>
          <th class="text-center">Acciones</th>
        </tr>
      </thead>
      <tbody>
        @for (notification of this.paginatedNotifications; track $index) {
        <tr>
          <td style="max-width: 400px; white-space: normal; word-break: break-word;">{{ notification.mensaje }}</td>
          <td class="text-center">
            <span 
              class="badge" 
              [class.bg-green-lt]="notification.active === 1" 
              [class.bg-red-lt]="notification.active === 0"
            >
              {{ notification.active === 1 ? 'Activo' : 'Inactivo' }}
            </span>
          </td>
          <td class="text-center">
            <span class="dropdown">
              <button
                class="btn dropdown-toggle align-text-top"
                data-bs-boundary="viewport"
                data-bs-toggle="dropdown"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <a
                  class="dropdown-item text-secondary-yellow cursor-pointer"
                  (click)="editNotification(notification)"
                  data-bs-toggle="modal"
                  data-bs-target="#notificationFormModal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-edit me-2"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                    <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                    <path d="M16 5l3 3" />
                  </svg>
                  Editar Notificación
                </a>
                <div class="dropdown-divider"></div>
                <a
                  class="dropdown-item cursor-pointer"
                  [class.text-warning]="notification.active === 1"
                  [class.text-success]="notification.active === 0"
                  (click)="toggleNotificationStatus(notification)"
                  [title]="notification.active === 1 ? 'Desactivar notificación' : 'Activar notificación'"
                >
                  @if (notification.active === 1) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="icon icon-tabler icons-tabler-outline icon-tabler-toggle-right me-2"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z" />
                    </svg>
                    Desactivar Notificación
                  } @else {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="icon icon-tabler icons-tabler-outline icon-tabler-toggle-left me-2"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z" />
                    </svg>
                    Activar Notificación
                  }
                </a>
              </div>
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="card-footer d-flex align-items-center">
    <app-pagination
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [itemsPerPage]="itemsPerPage"
      (pageChange)="onPageChange($event)"
    ></app-pagination>
  </div>
</div>
<app-notifications-form [notificationToEdit]="notificationToEdit()" (notificationCreated)="onNotificationCreated()" />
